module.exports = __webpack_public_path__ + "static/zep-90e5baf8c80afb7aea7424f1150ff046.jpg";